import { useState } from 'react';
import Box from '@mui/material/Box';
import dynamic from 'next/dynamic';


const ProductToggleDesriptions = dynamic(() => import('./ProductToggleDesriptions'))
const ProductToggleButtons = dynamic(() => import('./ProductToggleButtons'))


const ProductToggle = (props) => {

    const {
        product,
        faqs,
        articles,
        videos,
        reviews,
        long_term_product,
        long_desc,
        width,
        depth,
        height,
        measurements,
        activeTab,
        // handleChange,
    } = props;

        // console.log(activeTab)
    const [alignment, setAlignment] = useState(activeTab);

    const handleToggleChange = (event, newAlignment) => {
        if(newAlignment == null) return;
        setAlignment(newAlignment);
    };


  return (
    <Box className='w-100 mb-10' sx={{flexDirection:'row'}}>
        <ProductToggleButtons
            alignment={alignment}
            handleToggleChange={handleToggleChange}
            product_description_long={product.product_description_long}
            faqs={faqs}
            measurements={measurements}
            articles={articles}
            videos={videos}
            reviews={reviews}
        />

        <ProductToggleDesriptions
            alignment={alignment}
            product={product}
            product_description_long={product.product_description_long}
            faqs={faqs}
            measurements={measurements}
            articles={articles}
            videos={videos}
            reviews={reviews}
            long_term_product={long_term_product}
            long_desc={long_desc}
            width={width}
            depth={depth}
            height={height}
        />


        
    </Box>



  )
}

export default ProductToggle
